/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function l(l,n){if(null==l&&null==n)return null;const u={};return null!=n&&(u.geometry=n),null!=l&&(u.where=l),u}export{l as serializeStreamServiceFilter};
